

export const API_METHODS = {
  GET: "GET",
  POST: "POST",
  PUT: "PUT",
  PATCH: "PATCH",
  DELETE: "DELETE",
};

export const SOCKET_BASE_URL = 'http://164.52.214.106:4005'

export const ENDPOINTS = {
  cpanelgetCaptcha: `api/o/captcha/cpanelLogin?id=${Date.now()}`,
  LoginGetCaptcha: `/api/o/otp/create`,
  changePhone: "api/o/supervisor/change/phone",
  changeEmail: "api/o/supervisor/change/email",

  login: "/auth/login",
  eddLogin: "/auth/edd/login",
  forgetPassword: "/api/o/supervisor/password/reset",
  logout: "/auth/logout",
  userContent: "/api/profile",
  getCaptcha: `api/o/captcha/forgetPassword?id=${Date.now()}`,
  getAllFuelPump: `/api/o/language/allLang`,
  getAllClients: `/api/corp/clients/list?withSelf=true`,
  getAllCurrencies: `/api/o/currencies`,
  getAddressLine: (id) => `/api/o/maputil/autocomplete?key=${id}`,

  getZoneById: (id) => `/api/zone/detail?id=${id}`,
  getAllZones: (page, sizePerPage, name) =>
    `api/zone/grid?rows=${sizePerPage}&name=${name}&page=${page}`,
  getCitiesFromCountry: (country) => `/api/city/select/data?country=${country}`,
  getAllZoneVendors: (page, sizePerPage, name) =>
    `/api/corp/client/vendor/data/vendors?page=1&rows=100&withSelf=true`,
  getAllZoneCLients: (id) =>
    `/api/corp/client/vendor/data/clients?page=1&rows=100&withSelf=true`,
  getCountries: `/api/o/country/list`,
  getStatesByCountry: (country) => `/api/o/country/${country}/states`,
  getCitiesByCountryAndState: (country, state) =>
    `/api/o/country/${country}/state/${state}/city/list`,

  getAllZonesList: `/api/zone/map/list`,
  getFilteredClients: (
    filterClientUniqueId,
    filterClientName,
    filterClientZone,
    filterClientCountry,
    filterClientCity
  ) =>
    `/api/corp/client/vendor/data/clients?page=1&rows=100&fullName=${filterClientName}&zone_id=${filterClientZone}&country=${filterClientCountry}&city=${filterClientCity}&withSelf=true&unique_id=${filterClientUniqueId}`,
  getFilteredVendors: (filterVendorName) =>
    `/api/corp/client/vendor/data/vendors?page=1&rows=100&fullName=${filterVendorName}&withSelf=true`,
  editZone: (zoneId) => `/api/zone/${zoneId}/edit`,
  saveNewZone: `/api/zone/save`,
  deleteZoneById: (id) => `/api/zone/delete?id=${id}`,
};

export const PackOptions = [
  {
    id: 1,
    value: "4",
    price: 20,
  },
  {
    id: 2,
    value: "20",
    price: 30,
  },
  {
    id: 3,
    value: "50",
    price: 50,
  },
  {
    id: 4,
    value: "100",
    price: 70,
  },
];

export const StatusOptions = [
  {
    id: 0,
    value: "Unpaid",
  },
  {
    id: 1,
    value: "Open",
  },
  {
    id: 2,
    value: "Packed",
  },
  {
    id: 3,
    value: "Dispatched",
  },
  {
    id: 4,
    value: "Delivered",
  },
];

export const AdhesiveCardTypes = [
  {
    id: 1,
    name: "Regular",
    desc: "Adheres to most surfaces, plastic, wood, paint and won't damage surface upon removal",
  },
  {
    id: 2,
    name: "Glass",
    desc: "Stickers come with an additional adhesive seal to adhere to outdoor and indoor windows.",
  },
  {
    id: 3,
    name: "Metal",
    desc: "Tougher adhesive and thicker materials to block interference when adhered to metal surfaces",
  },
];
export const adminHeaders = ["Date", "Order No.", "Quantity", "Cost", "Status"];

export const sideNavItems = [
  {
    link: "/orders",
    name: "Orders",
    role: "User",
    picture: "/assets/images/orders-icon.png",
  },
  {
    link: "/account",
    name: "Account",
    role: "User",
    picture: "../../assets/images/orders-icon.png",
  },
  {
    link: "/products",
    name: "Products",
    role: "Admin",
    picture: "../../assets/images/orders-icon.png",
  },
];

export const products = [
  {
    picture: "../../assets/images/qr-image.png",
    name: "Covid Stickers Glass",
    price: "$40 NZD",
  },
  {
    picture: "../../assets/images/qr-image.png",
    name: "Covid Stickers Glass",
    price: "$40 NZD",
  },
  {
    picture: "../../assets/images/qr-image.png",
    name: "Covid Stickers Glass",
    price: "$40 NZD",
  },
  {
    picture: "../../assets/images/qr-image.png",
    name: "Covid Stickers Glass",
    price: "$40 NZD",
  },
  {
    picture: "../../assets/images/qr-image.png",
    name: "Covid Stickers Glass",
    price: "$40 NZD",
  },
  {
    picture: "../../assets/images/qr-image.png",
    name: "Covid Stickers Glass",
    price: "$40 NZD",
  },
];

export const MapStyles = [
  {
    featureType: "water",
    elementType: "geometry",
    stylers: [{ color: "#e9e9e9" }, { lightness: 17 }],
  },
  {
    featureType: "landscape",
    elementType: "geometry",
    stylers: [{ color: "#f5f5f5" }, { lightness: 20 }],
  },
  {
    featureType: "road.highway",
    elementType: "geometry.fill",
    stylers: [{ color: "#ffffff" }, { lightness: 17 }],
  },
  {
    featureType: "road.highway",
    elementType: "geometry.stroke",
    stylers: [{ color: "#ffffff" }, { lightness: 29 }, { weight: 0.2 }],
  },
  {
    featureType: "road.arterial",
    elementType: "geometry",
    stylers: [{ color: "#ffffff" }, { lightness: 18 }],
  },
  {
    featureType: "road.local",
    elementType: "geometry",
    stylers: [{ color: "#ffffff" }, { lightness: 16 }],
  },
  {
    featureType: "poi",
    elementType: "geometry",
    stylers: [{ color: "#f5f5f5" }, { lightness: 21 }],
  },
  {
    featureType: "poi.park",
    elementType: "geometry",
    stylers: [{ color: "#dedede" }, { lightness: 21 }],
  },
  {
    elementType: "labels.text.stroke",
    stylers: [{ visibility: "on" }, { color: "#ffffff" }, { lightness: 16 }],
  },
  {
    elementType: "labels.text.fill",
    stylers: [{ saturation: 36 }, { color: "#333333" }, { lightness: 40 }],
  },
  {
    elementType: "labels.icon",
    stylers: [{ visibility: "off" }],
  },
  {
    featureType: "transit",
    elementType: "geometry",
    stylers: [{ color: "#f2f2f2" }, { lightness: 19 }],
  },
  {
    featureType: "administrative",
    elementType: "geometry.fill",
    stylers: [{ color: "#fefefe" }, { lightness: 20 }],
  },
  {
    featureType: "administrative",
    elementType: "geometry.stroke",
    stylers: [{ color: "#fefefe" }, { lightness: 17 }, { weight: 1.2 }],
  },
];



